import load from "load-script"

import Script from "./script"

class DemandManager extends Script {
  constructor(settings) {
    super({
      accountID: "",
      videoAdUnit: {},
      ...settings,
    })

    this.service = {
      que: [],
    }
  }

  load() {
    window.pbjs = this.service
    load(
      `//micro.rubiconproject.com/prebid/dynamic/${this.settings.accountID}.js`
    )
  }

  push(command) {
    this.service.que.push(command)
  }

  bid(adPositionPairs, _callback) {
    this.push(() => {
      this.service.rp.requestBids({
        callback: _callback,
        gptSlotObjects: Object.values(adPositionPairs),
      })
    })
  }

  bidVideo(_callback) {
    let custParams = ""
    if (Object.entries(this.settings.videoAdUnit).length !== 0) {
      this.push(() => {
        this.service.rp.requestVideoBids({
          adSlotName: this.settings.videoAdUnit.path,
          playerSize: this.settings.videoAdUnit.size,
          callback: (response) => {
            try {
              let parsedUrl = new URL(response.adTagUrl)
              let searchParams = new URLSearchParams(parsedUrl.search)
              if (searchParams.has("cust_params")) {
                // dont encode uri: URLSearchParams already does it
                custParams = searchParams.get("cust_params")
                custParams = `&${custParams}`
                this._debugger("demand-manager", "custParams: ", custParams)
              }
            } catch (e) {
              // adTagUrl undefined or empty
              this._debugger("demand-manager", "catched error: " + e)
              this._debugger("demand-manager", "adTagUrl undefined or empty")
              custParams = ""
            } finally {
              return _callback(custParams)
            }
          },
        })
      })
    } else {
      return _callback(custParams)
    }
  }

  setTargeting() {
    // Not needed: the Demand Manager library does this automatically after bids are received.
    // this.service.setTargetingForGPTAsync()
  }
}

export default DemandManager
